<div class="container">
  @if (enableReporting) {
    <span class="link-btn" [hasHTMLTags]="true" fiTranslation="HEADER_LINK_REPORTING"></span>
  }
  <span class="link-btn" [hasHTMLTags]="true" fiTranslation="HEADER_LINK_SUPPORT"></span>
  <fi-user-menu
    [adminMandant]="adminMandant"
    [enableReporting]="enableReporting"
    [profileData]="profileData"
    [isMobile]="isMobile"
    [isUserMenuActive]="activeItem === 'user'"
    [isBurgerMenuActive]="activeItem === 'burger'"
    (setActiveItem)="setActiveItem($event)"
    class="header-action-item">
  </fi-user-menu>
</div>
